import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import ruLocale from 'date-fns/locale/ru';
import enDateLocale from 'date-fns/locale/en-GB';

export const i18nLoaded = i18n
  // detect user language
  .use(LanguageDetector)
  // load translation using xhr -> see /public/locales
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV !== 'production',
    load: 'languageOnly', // only "en", not "en-GB"
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: {
      loadPath:
        process.env.NODE_ENV !== 'production'
          ? '/locales/{{lng}}/{{ns}}.json'
          : '/auth/locales/{{lng}}/{{ns}}.json'
    }
  });

export default i18n;

i18n.on('languageChanged', (language: string) => {
  const result = language.match(/([a-z]*)-/i);
  if (result && result[1] && result[1] !== language) {
    i18n.changeLanguage(result[1]);
  }
});

export function dateLocaleByLanguage(language?: string) {
  switch (language) {
    case 'ru':
      return ruLocale;
    case 'en':
      return enDateLocale;
    default:
      return enDateLocale;
  }
}
